import React, { memo } from "react";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import PanoramaFishEyeIcon from "@mui/icons-material/PanoramaFishEye";
import {
     NoIcon,
     UnlockIcon,
     EditIcon,
     DeleteIcon,
} from "../../../styles/images/svg/DashboardGridIcons";
import DoneIcon from "@mui/icons-material/Done";
import ClearIcon from "@mui/icons-material/Clear";

export const UiGridType = memo((props) => {
     const { name } = props;
     return (
          <>
               <p className="sbt-data-grid__type">{name}</p>
          </>
     );
});

export const NotApprovedIcon = memo((props) => {
     const { name } = props;
     return (
          <>
               <ClearIcon className="sba-approved-icon" />
          </>
     );
});

export const ApprovedIcon = memo((props) => {
     const { name } = props;
     return (
          <>
               <DoneIcon className="sba-clear-icon" />
          </>
     );
});

export const GridStatus = memo((props) => {
     const { status } = props;
     return (
          <>
               {status == "Ongoing" && (
                    <p className="sbt-data-grid__status sbt-data-grid__status__ongoing">
                         {status}
                    </p>
               )}
               {status === "Completed" && (
                    <p className="sbt-data-grid__status sbt-data-grid__status__ended">
                         {status}
                    </p>
               )}
               {status === "Disabled" && (
                    <p className="sbt-data-grid__status sbt-data-grid__status__disabled">
                         {status}
                    </p>
               )}
               {status === "Scheduled" && (
                    <p className="sbt-data-grid__status sbt-data-grid__status__ongoing">
                         {status}
                    </p>
               )}
          </>
     );
});

export const UploadStatus = memo((props) => {
     const { status } = props;
     return (
          <>
               {status === "QUEUED" && (
                    <p className="sbt-data-grid__status sbt-data-grid__status__ended">
                         Queued
                    </p>
               )}
               {status === "UPLOADED" && (
                    <p className="sbt-data-grid__status sbt-data-grid__status__ended">
                         Uploaded
                    </p>
               )}
               {status === "PROCESSING" && (
                    <p className="sbt-data-grid__status sbt-data-grid__status__data_upload_processing">
                         Processing
                    </p>
               )}
               {status === "COMPLETED" && (
                    <p className="sbt-data-grid__status sbt-data-grid__status__ongoing">
                         Completed
                    </p>
               )}
               {status === "FAILED" && (
                    <p className="sbt-data-grid__status sbt-data-grid__status__data_upload_failed">
                         Failed
                    </p>
               )}
               {status === "COMPLETED WITH ERRORS" && (
                    <p className="sbt-data-grid__status sbt-data-grid__status__disabled">
                         Completed With Errors
                    </p>
               )}
               {status === "STAGING" && (
                    <p className="sbt-data-grid__status sbt-data-grid__status__disabled">
                         Staging
                    </p>
               )}
          </>
     );
});

export const GridActionBar = memo((props) => {
     const { status } = props;
     return (
          <>
               <div className="sbt-data-grid__action-bar">
                    <UnlockIcon />
                    <EditIcon />
                    {/* <DeleteIcon/> */}
               </div>
          </>
     );
});
export const ManageDataGridActionBar = memo((props) => {
     const {} = props;
     return (
          <>
               <div className="sbt-data-grid__action-bar">
                    <UnlockIcon />
                    <EditIcon />
               </div>
          </>
     );
});
